import { apiService } from '../apiService'

export const userManagementApiService = apiService.injectEndpoints({
  endpoints: (builder) => ({
    getRoles: builder.query({
      query: ({ offset, limit, searchQuery }) => {
        return {
          url: `/Role/GetRoles`,
          params: { offset, limit, searchQuery },
        }
      },
      transformResponse: (response) => {
        return response
      },
      providesTags: ['GetRoles'],
    }),
    getRoleCapabilities: builder.query({
      query: (roleCode) => {
        return {
          url: '/Role/GetRoleByRoleCode',
          params: { roleCode },
        }
      },
      providesTags: ['GetRoleCapabilities'],
      transformResponse: (response) => {
        return response.data
      },
    }),
    deleteRole: builder.mutation({
      query: (roleCode) => {
        return {
          url: '/Role/DeleteRole',
          method: 'DELETE',
          params: { roleCode },
        }
      },
      invalidatesTags: ['GetRoles'],
    }),
    getDomainName: builder.query({
      query: () => '/User/GetDomainName',
      transformResponse: (response) => {
        return response.data
      },
      providesTags: ['GetDomainName'],
    }),
    getAppTypesWithRoles: builder.query({
      query: (isMasterRole = false) => {
        return {
          url: `/Role/GetApplicationTypesWithRoles`,
          params: { isMasterRole },
        }
      },
      transformResponse: (response) => {
        return response.data
      },

      providesTags: ['GetAppTypesWithRoles'],
    }),
    getUsers: builder.query({
      query: (args) => {
        const { offSet, limit, userTypeId, searchQuery, userStatus } = args
        return {
          url: `/User/GetUsers`,
          params: { offSet, limit, userTypeId, searchQuery, userStatus },
        }
      },
      transformResponse: (response) => {
        return response
      },
      providesTags: ['GetUsers'],
    }),
    getAppCapabilities: builder.query({
      query: (appTypeCode) => {
        return {
          url: '/Role/GetCapabilites',
          params: {
            applicationTypeCode: appTypeCode,
          },
        }
      },
      providesTags: ['GetAppCapabilities'],
      transformResponse: (response) => {
        return response.data
      },
    }),
    addRole: builder.mutation({
      query: (roleDetails) => {
        return {
          url: '/Role/AddRole',
          method: 'POST',
          body: roleDetails,
        }
      },
      invalidatesTags: ['GetRoles'],
    }),
    updateRole: builder.mutation({
      query: (roleDetails) => {
        return {
          url: 'Role/UpdateRole',
          method: 'POST',
          body: roleDetails,
        }
      },
      invalidatesTags: ['GetRoles'],
    }),
    getApprovedCustomers: builder.query({
      query: () => {
        return {
          url: `/Customer/GetApprovedCustomers`,
        }
      },
      transformResponse: (response) => {
        return response.data
      },

      providesTags: ['GetApprovedCustomers'],
    }),
    addUserDetails: builder.mutation({
      query: (userDetails) => {
        return {
          url: '/User/AddUser',
          method: 'POST',
          body: userDetails,
        }
      },
      invalidatesTags: ['GetUsers'],
      transformResponse: (response) => {
        return response
      },
    }),
    updateUserDetails: builder.mutation({
      query: (userDetails) => {
        return {
          url: '/User/UpdateUser',
          method: 'POST',
          body: userDetails,
        }
      },
      invalidatesTags: ['GetUsers'],
      transformResponse: (response) => {
        return response
      },
    }),
    getUserDetailsById: builder.query({
      query: (userId) => {
        return {
          url: '/User/GetUserDetailesByUserId',
          params: { userId },
        }
      },
      transformResponse: (response) => {
        return response.data
      },
      providesTags: ['GetUserDetailsById'],
    }),
    UpdateUserAccountState: builder.mutation({
      query: (args) => {
        const { userId, accountEnabled } = args
        return {
          url: `/User/UpdateUserAccountState`,
          method: 'POST',
          params: { userId, accountEnabled },
        }
      },
      invalidatesTags: ['GetUsers'],
      transformResponse: (response) => {
        return response
      },
    }),
    getMasterRoles: builder.query({
      query: ({ offset, limit, searchQuery }) => {
        return {
          url: `/Role/GetMasterRoles`,
          params: { offset, limit, searchQuery },
        }
      },
      transformResponse: (response) => {
        return response
      },
      providesTags: ['GetMasterRoles'],
    }),
    addMasterRole: builder.mutation({
      query: (roleDetails) => {
        return {
          url: '/Role/AddMasterRole',
          method: 'POST',
          body: roleDetails,
        }
      },
      invalidatesTags: ['GetMasterRoles'],
    }),
    getUserLogActivity: builder.query({
      query: (userId: string) => {
        return {
          url: '/ActivityLog/GetUserActivityLog',
          params: { userId },
        }
      },
      transformResponse: (response) => {
        return response
      },
      providesTags: ['GetUserLogActivity'],
    }),
    getRoleActivity: builder.query({
      query: (roleCode) => {
        return {
          url: `/Role/GetRoleLogActivity`,
          params: { roleCode },
        }
      },
      transformResponse: (response) => {
        return response.data
      },
      providesTags: ['GetRoleActivity'],
    }),
    recoverRole: builder.mutation({
      query: (roleCode) => {
        return {
          url: '/Role/RecoverRole',
          method: 'POST',
          params: { roleCode },
        }
      },
      invalidatesTags: ['GetRoles', 'GetMasterRoles'],
    }),
  }),
})

export const {
  useLazyGetRolesQuery,
  useLazyGetRoleCapabilitiesQuery,
  useDeleteRoleMutation,
  useLazyGetDomainNameQuery,
  useLazyGetUsersQuery,
  useLazyGetAppTypesWithRolesQuery,
  useLazyGetAppCapabilitiesQuery,
  useAddRoleMutation,
  useUpdateRoleMutation,
  useLazyGetApprovedCustomersQuery,
  useAddUserDetailsMutation,
  useUpdateUserDetailsMutation,
  useLazyGetUserDetailsByIdQuery,
  useUpdateUserAccountStateMutation,
  useLazyGetMasterRolesQuery,
  useAddMasterRoleMutation,
  useLazyGetUserLogActivityQuery,
  useLazyGetRoleActivityQuery,
  useRecoverRoleMutation,
} = userManagementApiService
